
import React from 'react';
import { Loader2 } from 'lucide-react';
import { format, isSameDay } from 'date-fns';
import DateSelector from './DateSelector';

interface DateSelectionGridProps {
  isLoading: boolean;
  dates: Date[];
  selectedDates: Date[];
  availableDates: Date[];
  mealPlansMap: Record<string, Array<{ 
    type: 'recipe' | 'composition';
    id: string;
    name: string;
    recipeIds?: string[];
    isQuickRecipe?: boolean;
    mealType: string;
    authorFirstName?: string;
    imageUrl?: string;
    storageImageUrl?: string;
    userImageUrl?: string;
  }>>;
  onDateToggle: (date: Date) => void;
}

const DateSelectionGrid: React.FC<DateSelectionGridProps> = ({
  isLoading,
  dates,
  selectedDates,
  availableDates,
  mealPlansMap,
  onDateToggle,
}) => {
  const getMealPlansForDate = (date: Date) => {
    const dateKey = format(date, 'yyyy-MM-dd');
    return mealPlansMap[dateKey] || null;
  };

  const isDateWithMealPlan = (date: Date) => {
    return availableDates.some(d => isSameDay(d, date));
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-4">
        <Loader2 className="h-5 w-5 animate-spin text-gray-500" />
        <span className="ml-2 text-sm text-gray-500">Loading available dates...</span>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {dates.map(date => {
        const isSelected = selectedDates.some(d => isSameDay(d, date));
        const hasMealPlan = isDateWithMealPlan(date);
        const mealPlans = getMealPlansForDate(date);
        
        return (
          <DateSelector
            key={date.toISOString()}
            date={date}
            isSelected={isSelected}
            hasMealPlan={hasMealPlan}
            mealPlans={mealPlans}
            onToggle={onDateToggle}
          />
        );
      })}
    </div>
  );
};

export default DateSelectionGrid;
